import HiddenTypography from 'components/hidden-typography/hidden-typography.component';
import { useTranslation } from 'react-i18next';
import { selectItemsCount } from 'redux/cart/cart.selectors';
import { useReduxSrAlert } from '../sr-alerts.hooks';

const SrCartTotalItemsAlert = () => {
  const { t } = useTranslation();
  const alertMessage = useReduxSrAlert(selectItemsCount, totalItemsCount =>
    t('drawer.cart.success.ariaAlert', { count: totalItemsCount }),
  );

  return <HiddenTypography role="alert">{alertMessage}</HiddenTypography>;
};
export default SrCartTotalItemsAlert;
